import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { fetchVoucherDetails, } from '../../Redux/Slices/reservationVoucherSlice';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Property } from '../../Services/Service';
import { useProperty } from '../../PropertyContext';

export const VoucherDetail = () => {
    const { selectedProperty } = useProperty();
    const { bonresid } = useParams();
    const dispatch = useDispatch();
    const [Pms, setPMS] = useState();
    const { data, loading } = useSelector((state) => state.voucher);

    useEffect(() => {
        if (bonresid) {
            dispatch(fetchVoucherDetails(bonresid));
        }
    }, [bonresid, dispatch]);


    const header = data?.Table?.[0];
    const rooms = data?.Table1 || [];
    // const hotelInfo = data?.Table3?.[0];
    const bookingInfo = data?.Table4?.[0];

    useEffect(() => {
        const FetchPMS = async () => {
            if (!selectedProperty?.PropertyID) return;

            try {
                const result = await Property();
                const matched = result.find(
                    p => p.PropertyID === selectedProperty.PropertyID
                );
                setPMS(matched || null);
            } catch (error) {
                console.log("error fetch PMS", error);
            }
        };
        FetchPMS();
    }, [selectedProperty]);

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">

                            <div className="card shadow-sm p-4">

                                <div className="row">

                                    {/* LEFT SIDE */}
                                    <div className="col-md-5 border-end">
                                        <div className="bg-light p-3" style={{ minHeight: "250px" }}>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h6 className="text-muted fw-bold">GUEST DETAILS</h6>
                                                <div>
                                                    {Pms?.PMS === "Opera" && (<NavLink to="/Reservation/EditBooking" state={{
                                                        header,
                                                        rooms,
                                                        bookingInfo
                                                    }} className="btn btn-sm"><i className='fas fa-edit fs-5'></i></NavLink>)}
                                                    {Pms?.PMS === "IdsNext" && (<NavLink to="/Reservation/EditBookingList" state={{
                                                        header,
                                                        rooms,
                                                        bookingInfo
                                                    }} className="btn btn-sm"><i className='fas fa-edit fs-5'></i></NavLink>)}
                                                </div>
                                            </div>
                                            <div className="">
                                                <h5 className="fw-bold">
                                                    <i className="bi bi-person-fill me-2"></i>
                                                    {header?.FirstName} {header?.LastName}
                                                </h5>
                                            </div>

                                            <hr />
                                            <div className="row">
                                                <div className="col-6">
                                                    <p className="text-muted mb-1">CHECK-IN</p>
                                                    <p className="fw-bold mb-0">{bookingInfo?.CheckInDate}</p>
                                                </div>

                                                <div className="col-6">
                                                    <p className="text-muted mb-1">CHECK-OUT</p>
                                                    <p className="fw-bold mb-0">{bookingInfo?.CheckOutDate}</p>
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <p className="text-muted mb-1">TOTAL NO. OF GUEST(S)</p>
                                                <p className="fw-bold">{header?.Adult} Adults + {header?.Child} Child</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div className="col-md-7  ">
                                        <div className="bg-light p-3" style={{ height: "250px" }}>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING ID</p>
                                                    <p className="fw-bold">{bookingInfo?.BONRESID}</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKED ON</p>
                                                    <p className="fw-bold">
                                                        {header?.BookingDate}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING STATUS</p>
                                                    <span className="badge bg-success">{bookingInfo?.BookingStatus}</span>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">PAYMENT STATUS</p>
                                                    <span className="badge bg-warning">{bookingInfo?.PaymentStatus}</span>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING SOURCE</p>
                                                    <p className="fw-bold">Book On Nile</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">CONFERMATION NO</p>
                                                    <p className="fw-bold">{bookingInfo?.PMSRESID}</p>
                                                </div>
                                            </div>




                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3" style={{ borderBottom: "2px solid #333" }}></div>

                                {/* ================= ROOM WISE PAYMENT BREAKUP ================= */}
                                <h5 className="fw-bold mt-3">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <span> Room wise Payment Breakup <small className="text-muted">(in ₹)</small></span>
                                    </div>
                                </h5>

                                <div className="table-responsive ">
                                    <table className="table table-bordered align-middle text-center">
                                        <thead className="table-light">
                                            <tr>

                                                <th>Meal Plan </th>
                                                <th>Rate Plan</th>
                                                <th>ADULT(S)</th>
                                                <th>CHILD</th>
                                                <th>Extra Adl/Chl </th>
                                                <th>Room Rate</th>
                                                <th>Taxes </th>
                                                <th>Net Rate </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {rooms.map((room, index) => {
                                                const showHeader =
                                                    index === 0 || rooms[index - 1].RoomName !== room.RoomName;
                                                return [
                                                    showHeader && (
                                                        <tr key={`header-${index}`} className="table-secondary">
                                                            <td colSpan="8" className="text-start fw-bold">
                                                                {room.RoomName}
                                                            </td>
                                                        </tr>
                                                    ),

                                                    <tr key={`row-${index}`}>
                                                        <td className='text-start'>{room.MeelPlan}</td>
                                                        <td className='text-start'>{room.RatePlan}</td>
                                                        <td>{room.adults}</td>
                                                        <td>{room.Child}</td>
                                                        <td>{room.ExtaCharge}</td>
                                                        <td>{room.RoomRate}</td>
                                                        <td>{room.TaxRate}</td>
                                                        <td>{room.NetAmount}</td>
                                                    </tr>
                                                ];
                                            })}

                                        </tbody>
                                        <tfoot>
                                            <tr className="fw-bold table-light">
                                                <td className="text-start">GRAND TOTAL</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{bookingInfo?.TotalPayment}</td>
                                                <td>{bookingInfo?.Tax}</td>
                                                <td>{bookingInfo?.TotalAfterTax}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <div className="bg-light p-3">

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <p className="text-muted mb-1">Booking Comment </p>
                                            <p className="fw-bold">{header?.BookingComment && JSON.parse(header.BookingComment)[0]?.BookingComment}</p>
                                        </div>

                                        <div className="col-md-6">
                                            <p className="text-muted mb-1">Payment Comment</p>
                                            <p className="fw-bold">
                                                {header?.PaymentComment && JSON.parse(header.PaymentComment)[0]?.PaymentComment}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Email</p>
                                            <span >{header?.Email}</span>
                                        </div>

                                        <div className="col-md-5">
                                            <p className="text-muted mb-1">Address</p>
                                            <span> {header?.Address}</span>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">city</p>
                                            <p className="fw-bold">{header?.City}</p>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">Country</p>
                                            <p className="fw-bold">{header?.Country}</p>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">State</p>
                                            <p className="fw-bold">{header?.State}</p>
                                        </div>

                                        <div className="col-md-4">
                                            <p className="text-muted mb-1">Company Name</p>
                                            <p className="fw-bold">{bookingInfo?.CompanyName}</p>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">Registration Number </p>
                                            <p className="fw-bold">{header?.RegTax_Number}</p>
                                        </div>

                                        <div className="col-md-4">
                                            <p className="text-muted mb-1">Registered Company name</p>
                                            <p className="fw-bold">{header?.Reg_CompName}</p>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <p className="text-muted mb-1">Registered Company address </p>
                                            <p className="fw-bold">{header?.RegCom_Address}</p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Billing Instructions</p>
                                            <p className="fw-bold"></p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Market Segment </p>
                                            <p className="fw-bold">{bookingInfo?.MarketSegment}</p>
                                        </div>


                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Business Source</p>
                                            <p className="fw-bold">{bookingInfo?.BusinessSource}</p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Guarantee Codes </p>
                                            <p className="fw-bold">{bookingInfo?.GuaranteeCodes}</p>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
